import { __exportAll } from "../../../../_virtual/_rolldown/runtime.js";
import { z } from "zod";
//#region src/central/v3/schedules/post/ex-date.ts
var ex_date_exports = /* @__PURE__ */ __exportAll({ RequestSchema: () => RequestSchema });
var PartnerDataSchema = z.object({ facebookPartnerData: z.object({
	crossposts: z.array(z.object({ destinationId: z.string() })).optional(),
	destinationId: z.string().optional(),
	thumbnailUploaded: z.boolean().optional(),
	type: z.string().optional()
}) });
var ContentDestinationScheduleSchema = z.object({
	autoArchive: z.boolean().optional(),
	autoArchivePlaylists: z.array(z.string()).optional(),
	channelId: z.string().optional(),
	description: z.string().optional(),
	durationSeconds: z.number().nullable().optional(),
	id: z.string().nullable().optional(),
	imageUrl: z.string().optional(),
	leadTimeMillis: z.number().optional(),
	mediaId: z.string().nullable().optional(),
	partnerData: PartnerDataSchema.optional(),
	privacy: z.string().optional(),
	publishStatus: z.enum([
		"created",
		"ready",
		"unpublished",
		"published",
		"scheduled_unpublished",
		"scheduled_published",
		"completed"
	]).optional(),
	published: z.boolean().optional(),
	realtimePlayback: z.boolean().optional(),
	rtmpDestinationId: z.string().optional(),
	startTimeOffsetMillis: z.number().optional(),
	title: z.string(),
	type: z.enum([
		"EMBED",
		"FACEBOOK",
		"RSP_SOURCE",
		"SAVEONLY",
		"RTMP",
		"YOUTUBE"
	]),
	webEncoderProfileId: z.string().optional(),
	webEventProfileId: z.string().optional()
});
var EncoderScheduleSchema = z.object({
	durationMillis: z.number(),
	encoderId: z.string(),
	encoderProfileId: z.string().optional(),
	eventProfileId: z.string(),
	localStartTime: z.string(),
	rrule: z.string().optional(),
	title: z.string()
});
var RequestSchema = z.object({
	contentDestinationSchedules: z.array(ContentDestinationScheduleSchema).optional(),
	description: z.string().optional(),
	durationSeconds: z.number().nullable().optional(),
	enabled: z.boolean().optional(),
	encoderSchedule: EncoderScheduleSchema.optional(),
	endDay: z.string().optional(),
	imageUrl: z.string().optional(),
	localStartTime: z.string().optional(),
	rrule: z.string().optional(),
	sourceAlignmentOffsetMillis: z.number().nullable().optional(),
	sourceEventId: z.string().optional(),
	startDay: z.string().optional(),
	startNow: z.boolean().optional(),
	streamType: z.enum([
		"SIMLIVE",
		"LIVE",
		"REPUBLISH",
		"EXISTING_ENCODER_EVENT",
		"EXISTING_MEDIA"
	]),
	syncDetails: z.boolean().optional(),
	timeZone: z.string().optional(),
	title: z.string()
});
//#endregion
export { ex_date_exports };

//# sourceMappingURL=ex-date.js.map